import { render, staticRenderFns } from "./PopupHis.vue?vue&type=template&id=2dec7cf4&scoped=true&"
import script from "./PopupHis.vue?vue&type=script&lang=js&"
export * from "./PopupHis.vue?vue&type=script&lang=js&"
import style0 from "./PopupHis.vue?vue&type=style&index=0&id=2dec7cf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dec7cf4",
  null
  
)

export default component.exports